import { EntitySearch, EntitySearchMultiParty } from '@components/entity-search';
import { RelationChip } from '@components/relation-chip';
import { toPercentage } from '@lib/common';
import { DealDetail, DealRelation, DealSourceType, EntityType } from '@lib/deals';
import { CompanyContentRelation } from '@lib/company-content-relations';
import {
  Divider,
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  TextField,
  InputLabel,
  Select,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import styled from 'styled-components';
import { ServicesPicker } from '../../company/form/fields/company-serivce-field/ServicesPicker_v2';
import { useCompanyMaster, useSnackbarInstance } from '@lib/common';
import getLoadingMessage from '@lib/common/loading-messages';
import { useController } from 'react-hook-form';
import React, { useEffect, useCallback, useRef, useState } from 'react';
import ClearIcon from '@material-ui/icons/Clear';

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Column } from 'react-table';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import { QueryParamsAdapter } from '@lib/common';
import { ServicesField } from './company-services'
import { usePintMaster } from '@lib/common';

export const COMPANY_TO_CONTENT = "company2content";
export function CompanyContentRelationForm({ relationData, createRelation = false }) {
  // console.log({"relationData":relationData});
  // console.log({"relationDatacretae": createRelation})
  const [associatedServices, setAssociatedServices] = useState([]);
  const params = QueryParamsAdapter.fromParams(location.search);
  const originalRelationId = params?.originalRelationId;
  const { master: services, loading } = useCompanyMaster('services');
  const filteredServices = useMemo(() => {
    // if (value && value.length && services && services.length) {
    //   return services.filter(s => !value.find(v => v.id === s.id));
    // }
    return loading ? services : [...services, { id: 835, service: 'Others' }];
  }, [services]);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [enableMultiContent, setEnableMultiContent] = useState(true);
  const [enableMultiClient, setEnableMultiClient] = useState(true);
  // const inputRef = React.createRef();

  const form = useFormContext();
  const todaysDate = useMemo(() => new Date(), []);
  const handleFocusOnServices = event => {
    setServicesOpen(prevVal => !prevVal);
    event.target.blur(); // remove the focus after setting up value
  };
  const addServices = services => {
    form.setValue('service_provided_id', services.id);
    form.setValue('company_service_name', services.service);
    setServicesOpen(prevVal => !prevVal);
  };
  const watchOnServiceId = form.watch('service_provided_id');
  // useEffect(() => {
  //   if (watchOnServiceId == 835) {
  //     form.setValue('is_publish', -1);
  //   }
  // }, [watchOnServiceId]);
  const { control } = useFormContext();
  // code for selecting multiple services in creation
  const setServices = (ser) => {
    // console.log({"services set":ser})
    setAssociatedServices(ser)
  }
  // const { loading_services, master: company_services } = usePintMaster('company_services');

  const removeService = useCallback(() => {
    form.setValue('service_provided_id', null);
    form.setValue('company_service_name', null);
  }, []);


  // code to add multiple content
  const [indexesDealBuyers, setIndexesDealBuyers] = useState(
    Array.from(Array(relationData.content_relation.length), (_, i) => i)
  );
  const [counterDealBuyers, setCounterDealBuyers] = useState(1);
  const addDealBuyers = useCallback(() => {
   // const watchOnBuyers = form.watch('buyers');
    setIndexesDealBuyers(prevIndexes => {
      return [...prevIndexes, counterDealBuyers];
    });
    setCounterDealBuyers(prevCounter => prevCounter + 1);
  }, [indexesDealBuyers, counterDealBuyers]);

  const removeDealBuyers = useCallback(index => {
    setIndexesDealBuyers(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
    const watchOnBuyers = form.watch('content_relation');
    watchOnBuyers
      .filter((x, idx) => idx !== index)
      .forEach((eachRow, idx) => {
        if (eachRow) eachRow['order_id'] = idx + 1;
      });

    setCounterDealBuyers(prevCounter => prevCounter - 1);
  }, [relationData]);


  const onChangeDraggedContent = allRowsModified => {
    const watchOnBuyers = form.watch('content_relation');
   /*  const modifiedRowsWithOrderId = allRowsModified.map((eachRow, idx) => {
      if (watchOnBuyers[eachRow.id]) {
        watchOnBuyers[eachRow.id]['order_id'] = idx + 1;
        return { ...watchOnBuyers[eachRow.id], order_id: idx + 1 };
      }
      return watchOnBuyers[eachRow.id];
    }); */
    setIndexesDealBuyers(allRowsModified.map(eachRow => eachRow.id));
    // form.setValue('ordered_buyers', modifiedRowsWithOrderId);
  }; 
  const columns: Column<any>[] = useMemo(
    () => [
      // {
      //   Header: '#',
      //   id: 'serial',
      //   accessor: (_row, idx) => idx + 1,
      //   width: 35,
      // },
      {
        Header: 'Cell',
        id: 'cell',
        // width: 200,
        Cell: ({ row, idx }) => {
          const isRowDeletetable = row.original.deleteable;
          const index = row.original.id;
          const fieldName = `content_relation[${index}]`;
          return (
            <Controller
              name={fieldName}
              key={index}
              control={form.control}
              defaultValue={
                relationData.content_relation[index]
                  ? relationData.content_relation[index]
                  : {
                    name: '',
                    type: EntityType.content,
                    vtr_id: '',
                    meta: null,
                    relation_type: 'content',
                    order_id: index + 1,
                  }
              }
              render={({ onChange }) => (
                <PaddingBottomEntitySearch key={index}>
                  <EntitySearchMultiParty
                    label="Content"
                    fixedType={EntityType.content}
                    defaultValue={
                      relationData.content_relation[index]
                        ? relationData.content_relation[index]
                        : {
                          name: '',
                          type: EntityType.content,
                          vtr_id: '',
                          meta: null,
                          relation_type: 'content',
                          order_id: index + 1,
                        }
                    }
                    hideTypeSelect
                    clearable
                    onChange={onChange}
                    // changeBuyer={changeBuyer}
                    titleEditable
                    indexOfEntities={index}
                    removeDealEntities={removeDealBuyers}
                    isDealEntityRemovable={isRowDeletetable}
                    dealData={form.getValues()}
                    // isDealEntityRequestCreatable={!createDeal}
                    txtMessage='/company/new'
                    page={COMPANY_TO_CONTENT}
                  />
                </PaddingBottomEntitySearch>
              )}
            />
          );
        },
      },
    ],
    [relationData.content_relation]
  );

  const getRowId = React.useCallback((row: any, idx) => {
    return '' + row.id;
  }, []);

  // code for clients

  const [indexesClients, setIndexesClients] = useState(
    Array.from(Array(relationData.client_relation.length), (_, i) => i)
  );
  const [counterClients, setCounterClients] = useState(1);
  const addClients = useCallback(() => {
    const watchOnBuyers = form.watch('client_relation');
    setIndexesClients(prevIndexes => {
      return [...prevIndexes, counterClients];
    });
    setCounterClients(prevCounter => prevCounter + 1);
  }, [indexesClients, counterClients]);

  const removeClients = useCallback(index => {
    setIndexesClients(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
    const watchClients = form.watch('client_relation');
    watchClients
      .filter((x, idx) => idx !== index)
      .forEach((eachRow, idx) => {
        if (eachRow) eachRow['order_id'] = idx + 1;
      });

    setCounterClients(prevCounter => prevCounter - 1);
  }, [relationData]);

 const onChangeDraggedClients = allRowsModified => {
  const watchOnClients = form.watch('client_relation');
   /*  const modifiedRowsWithOrderId = allRowsModified.map((eachRow, idx) => {
      if (watchOnClients[eachRow.id]) {
        watchOnClients[eachRow.id]['order_id'] = idx + 1;
        return { ...watchOnClients[eachRow.id], order_id: idx + 1 };
      }
      return watchOnClients[eachRow.id];
    }); */
    setIndexesClients(allRowsModified.map(eachRow => eachRow.id));
    
};

  const clientColumns: Column<any>[] = useMemo(
    () => [
      // {
      //   Header: '#',
      //   id: 'serial',
      //   accessor: (_row, idx) => idx + 1,
      //   width: 35,
      // },
      {
        Header: 'Cell',
        id: 'cell',
        // width: 200,
        Cell: ({ row, idx }) => {
          const isRowDeletetable = row.original.deleteable;
          const index = row.original.id;
          const fieldName = `client_relation[${index}]`;
          return (
            <Controller
              name={fieldName}
              key={index}
              control={form.control}
              // defaultValue={null}
              defaultValue={
                relationData.client_relation[index]
                  ? relationData.client_relation[index]
                  : {
                    name: '',
                    type: EntityType.company,
                    vtr_id: '',
                    meta: null,
                    relation_type: 'client_relation',
                    order_id: index + 1,
                  }
              }
              render={({ onChange }) => (
                <PaddingBottomEntitySearch key={index}>
                  <EntitySearchMultiParty
                    label="Client"
                    fixedType={EntityType.company}
                    defaultValue={
                      relationData.client_relation[index]
                        ? relationData.client_relation[index]
                        : {
                          name: '',
                          type: EntityType.company,
                          vtr_id: '',
                          meta: null,
                          relation_type: 'company',
                          order_id: index + 1,
                        }
                    }
                    hideTypeSelect
                    clearable
                    onChange={onChange}
                    // changeBuyer={changeBuyer}
                    titleEditable
                    indexOfEntities={index}
                    removeDealEntities={removeClients}
                    isDealEntityRemovable={isRowDeletetable}
                    dealData={form.getValues()}
                    // isDealEntityRequestCreatable={!createDeal}
                    txtMessage='/company/new'
                  />
                </PaddingBottomEntitySearch>
              )}
            />
          );
        },
      },
    ],
    [relationData.client_relation]
  );

  const getClientRowId = React.useCallback((row: any, idx) => {
    return '' + row.id;
  }, []);

/* 
  const onChangeDraggedRows = allRowsModified => {
    const watchOnBuyers = form.watch('content_relation');
    const modifiedRowsWithOrderId = allRowsModified.map((eachRow, idx) => {
      if (watchOnBuyers[eachRow.id]) {
        watchOnBuyers[eachRow.id]['order_id'] = idx + 1;
        return { ...watchOnBuyers[eachRow.id], order_id: idx + 1 };
      }
      return watchOnBuyers[eachRow.id];
    });
    setIndexesDealBuyers(allRowsModified.map(eachRow => eachRow.id));
    // form.setValue('ordered_buyers', modifiedRowsWithOrderId);
  }; */
  return (
    <div>
      {
        <>
          <Typography variant="h6" gutterBottom>
            Company
          </Typography>
          <Controller
            name="company_relation"
            control={form.control}
            defaultValue={
              relationData.company_relation
                ? relationData.company_relation
                : {
                  name: '',
                  type: EntityType.company,
                  vtr_id: '',
                  meta: null,
                  relation_type: 'company',
                  order_id: 1,
                }
            }
            render={({ onChange }) => (
              <>
                <PaddingBottomEntitySearch>
                  <EntitySearchMultiParty
                    label="Company"
                    fixedType={EntityType.company}
                    defaultValue={
                      relationData.company_relation
                        ? relationData.company_relation
                        : {
                          name: '',
                          type: EntityType.company,
                          vtr_id: '',
                          meta: null,
                          relation_type: 'company',
                          order_id: 1,
                        }
                    }
                    hideTypeSelect
                    clearable
                    onChange={onChange}
                    // titleEditable
                    indexOfEntities={1}
                  />
                </PaddingBottomEntitySearch>
              </>
            )}
          />
        </>
      }

      {(!createRelation || originalRelationId) ? (
        <div>
          <Typography variant="h6" gutterBottom>
            Content
          </Typography>
          <Controller
            name="content_relation"
            control={form.control}
            defaultValue={
              relationData.content_relation
                ? relationData.content_relation
                : {
                  name: '',
                  type: EntityType.content,
                  vtr_id: '',
                  meta: null,
                  relation_type: 'content',
                  order_id: 1,
                }
            }
            render={({ onChange }) => (
              <>
                <PaddingBottomEntitySearch>
                  <EntitySearchMultiParty
                    label="Content"
                    fixedType={EntityType.content}
                    defaultValue={
                      relationData.content_relation
                        ? relationData.content_relation
                        : {
                          name: '',
                          type: EntityType.content,
                          vtr_id: '',
                          meta: null,
                          relation_type: 'content',
                          order_id: 1,
                        }
                    }
                    hideTypeSelect
                    clearable
                    onChange={onChange}
                    // titleEditable
                    indexOfEntities={1}
                    page={COMPANY_TO_CONTENT}
                  />
                </PaddingBottomEntitySearch>
              </>
            )}
          /> </div>) :
        (
          <div>
            <div style={{ display: 'flex' }}>
              <Typography variant="h6" gutterBottom>
                Content
              </Typography>
              <Grid item style={{ paddingRight: '20px', paddingBottom: '10px', marginLeft: 'auto' }}>
                {/* <div> */}
                <Tooltip title="Add Content">
                  <StyledFab onClick={addDealBuyers} disabled={counterClients > 1} color="primary" aria-label="add" size="small">
                    <AddIcon />
                  </StyledFab>
                </Tooltip>
                {/* </div> */}
              </Grid>
            </div>
            <fieldset style={{ padding: '0.75em', backgroundColor: '#f5f5f5', border: 'none' }}>
              <DraggableRowsTableStyled
                getRowId={getRowId}
                onChange={onChangeDraggedContent}
                columns={columns}
                data={indexesDealBuyers.map(idx => ({
                  id: idx,
                  deleteable: indexesDealBuyers.length > 1,
                }))}
                stickyHeader
                size="small"
                hideHeaders
                showDragIcon={false}
              />
            </fieldset>
          </div>
        )}

      <br/>
      {(!createRelation || originalRelationId) ? (
        <div>
          <Typography variant="h6" gutterBottom>
            Client
          </Typography>
          <Controller
            name="client_relation"
            control={form.control}
            defaultValue={
              relationData.client_relation
                ? relationData.client_relation
                : {
                  name: '',
                  type: EntityType.company,
                  vtr_id: '',
                  meta: null,
                  relation_type: 'company',
                  order_id: 1,
                }
            }
            render={({ onChange }) => (
              <>
                <PaddingBottomEntitySearch>
                  <EntitySearchMultiParty
                    label="Company"
                    fixedType={EntityType.company}
                    defaultValue={
                      relationData.client_relation
                        ? relationData.client_relation
                        : {
                          name: '',
                          type: EntityType.company,
                          vtr_id: '',
                          meta: null,
                          relation_type: 'company',
                          order_id: 1,
                        }
                    }
                    hideTypeSelect
                    clearable
                    onChange={onChange}
                    // titleEditable
                    indexOfEntities={1}
                  />
                </PaddingBottomEntitySearch>
              </>
            )}
          /></div>) :
        (
          <div>
            <div style={{ display: 'flex' }}>
              <Typography variant="h6" gutterBottom>
                Client
              </Typography>
              <Grid item style={{ paddingRight: '20px', paddingBottom: '10px', marginLeft: 'auto' }}>
                {/* <div> */}
                <Tooltip title="Add Content">
                  <StyledFab onClick={addClients} disabled={counterDealBuyers > 1} color="primary" aria-label="add" size="small">
                    <AddIcon />
                  </StyledFab>
                </Tooltip>
                {/* </div> */}
              </Grid>
            </div>
            <fieldset style={{ padding: '0.75em', backgroundColor: '#f5f5f5', border: 'none' }}>
              <DraggableRowsTableStyled
                getRowId={getClientRowId}
                onChange={onChangeDraggedClients}
                columns={clientColumns}
                data={indexesClients.map(idx => ({
                  id: idx,
                  deleteable: indexesClients.length > 1,
                }))}
                stickyHeader
                size="small"
                hideHeaders
                showDragIcon={false}
              />
            </fieldset>
          </div>
        )}
        <br/>
      <Typography variant="h6" gutterBottom>
        Services
      </Typography>
      {(!createRelation || originalRelationId) ?
        <ControlledTextField
          fullWidth
          variant="outlined"
          multiline
          rowsMax={4}
          name={'company_service_name'}
          label={'Service Name'}
          control={form.control}
          onFocus={handleFocusOnServices}
          removeService={removeService}
        /> :
        <ServicesField services={[]} selected_services={[]} setServices={setServices} control={control} name="service_provided_id" />

      }
      <Grid item>
        {!loading && services && (
          <ServicesPicker
            open={servicesOpen}
            services={filteredServices}
            onServiceAdd={addServices}
          />
        )}
        {loading && (
          <Typography variant="body2" color="textSecondary">
            {getLoadingMessage()}
          </Typography>
        )}
      </Grid>
      <br />
      <Typography variant="h6" gutterBottom>
        Data Source Link
      </Typography>
      <ControlledTextField
        fullWidth
        multiline
        rowsMax={4}
        variant="outlined"
        name={'data_source_link'}
        label={'Data Source Link'}
        control={form.control}
      />

      <Divider />
      <br />
    </div>
  );
}

const ControlledTextField = ({ name, control, removeService = null, ...props }) => {
  const {
    field: { value, onChange },
  } = useController({ name, control, defaultValue: '' });
  const callbackOnChange = useCallback(e => onChange(e.target.value), [onChange]);
  if (removeService) {
    return (
      <TextField
        {...props}
        name={name}
        value={value || ''}
        onChange={callbackOnChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <ClearIcon onClick={removeService} style={{ cursor: 'pointer' }} />
            </InputAdornment>
          ),
        }}
      />
    );
  } else {
    return <TextField {...props} name={name} value={value || ''} onChange={callbackOnChange} />;
  }
};

const PaddingBottomEntitySearch = styled.div`
  margin-bottom: 20px;
  :last-child {
    margin-bottom: 0px;
  }
`;

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;

const DraggableRowsTableStyled = styled(DraggableRowsTable)`
  & .MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall {
    padding-bottom: 10px;
    padding-top: 10px;
  }
`;
